// extracted by mini-css-extract-plugin
module.exports = {"inner":"Recruit-module--inner--212h1","wanted":"Recruit-module--wanted--1rskW","wanted_link":"Recruit-module--wanted_link--Lo2jA"};